import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { PRIVACY_POLICY_PATH } from '../core/constants/site';

import HomePage from '../pages/public/home';
import PrivacyPolicyPage from '../pages/public/privacy-policy';
import NotFoundPage from '../pages/not-found';

// TSS vite/01 — app shell. Marketing site with no backend: every route is
// public, so Auth/QueryClient providers and route guards are intentionally
// absent. See docs/decisions/0001-landing-estatica-sin-shell-de-auth.md.
//
// Each route maps to a real .html entry in the build (index.html,
// politica-de-datos.html, 404.html) so shared hosting serves them without
// an SPA rewrite rule; the router only picks which page that entry renders.
export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/index.html" element={<HomePage />} />
                <Route path={PRIVACY_POLICY_PATH} element={<PrivacyPolicyPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </BrowserRouter>
    );
}
